var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "_Icons/Map/Pin Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCCF_Circulation-Rules",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circulation-Rules_-Porto",
    transform: "translate(-36.000000, -294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-pin",
    transform: "translate(36.000000, 294.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20.9 L16.95,15.95 C19.6834648,13.2162562 19.6833141,8.78423123 16.9496633,6.05067343 C14.2160125,3.31711563 9.7839875,3.31711563 7.05033671,6.05067343 C4.31668593,8.78423123 4.31653518,13.2162562 7.05,15.95 L12,20.9 Z M5.636,17.364 C2.12131304,13.84927 2.12133631,8.15080522 5.63605196,4.63610392 C9.15076761,1.12140261 14.8492324,1.12140261 18.363948,4.63610392 C21.8786637,8.15080522 21.878687,13.84927 18.364,17.364 L12.7071068,23.0208932 C12.3165825,23.4114175 11.6834175,23.4114175 11.2928932,23.0208932 L5.636,17.364 L5.636,17.364 Z M12,13 C13.1045695,13 14,12.1045695 14,11 C14,9.8954305 13.1045695,9 12,9 C10.8954305,9 10,9.8954305 10,11 C10,12.1045695 10.8954305,13 12,13 Z M12,15 C9.790861,15 8,13.209139 8,11 C8,8.790861 9.790861,7 12,7 C14.209139,7 16,8.790861 16,11 C16,13.209139 14.209139,15 12,15 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.5ab869746e671ede2b8413d7bb9f13a9.svg";
export { ForwardRef as ReactComponent };